// extracted by mini-css-extract-plugin
export var navbar = "Navbar-module--navbar--2iwn6";
export var link = "Navbar-module--link--2WGT8";
export var menu = "Navbar-module--menu--3wmGU";
export var toggled = "Navbar-module--toggled--Cii08";